import './project.css';
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL } from './axios';
// import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, YAxis, LineChart } from 'recharts';
import { handleErrorToast, customSortByKey } from '../../utils/ReusableFunctions';
import { AddwithWhiteCircle, UpdatePencil, DeleteDustbin, AddwithBlueCircle, UpdatePencilWhite } from '../../utils/ReusableSVGs';
import { IndianStatesAndUTs } from '../../utils/CommonVariables';
import { Modal } from "react-bootstrap";
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, YAxis, LineChart } from 'recharts';
import Select from "react-select";


const AddProjectDetails = ({ getProjects }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    };

    const [clientList, setClientList] = useState([]);
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [empList, setEmpList] = useState([]);
    const [formData, setFormData] = useState({
        site_prcode: "",
        project_name: "",
        project_short_name: "",
        location: "",
        concern_person_name: "",
        tender_id: "",
        project_length: "",
        ro: "",
        ro_address: "",
        piu_address: "",
        agreement_date: null,
        commencement_date: null,
        project_duration: "",
        om_duration: "",
        construction_duration: "",
        client_name: "",
        project_completion_date: null,
        bid_due_date: null,
        work_type: "",
        remark: "",
        project_key_point: "",
        project_cost_replace: "",
        contract_mode: "",
        status: "",
        sub_company: "",
        admin_approval_for_dlt: false,
        req_raised_by_AE: "",
        esclation: "",
        is_escalation_added: false,
        our_services: "",

        notice_intivite_tender_id: "",
        project_mode: "",
        project_form: "",
        project_to: "",
        spv: "",
        nh_no: "",
        name_of_dpr_consultant: "",
        RFP_invited: "",
        bid_security: "",
        LOR: "",
        CA_signed: "",
        Appointment_date: "",
        BPC_of_concessionaire: "",
        EPC: "",
        performance_security: "",
        additional_performance_security: "",
        mobilization_advance_after_AD: "",
        approval_of_GAD_of_ROB: "",
        sub_contractor: '',
        consultant: '',
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleClose = () => {
        setShow(false);
        setFormData({

            project_name: "",
            project_short_name: "",
            location: "",
            concern_person_name: "",
            tender_id: "",
            project_length: "",
            ro: "",
            ro_address: "",
            piu_address: "",
            agreement_date: null,
            commencement_date: null,
            project_duration: "",
            om_duration: "",
            construction_duration: "",
            client_name: "",
            project_completion_date: null,
            bid_due_date: null,

            project_key_point: "",
            project_cost_replace: "",
            contract_mode: "",
            status: "",
            sub_company: "",
            admin_approval_for_dlt: false,
            req_raised_by_AE: "",
            esclation: "",
            is_escalation_added: false,
            our_services: "",

            notice_intivite_tender_id: "",
            project_mode: "",
            project_form: "",
            project_to: "",
            spv: "",
            nh_no: "",
            name_of_dpr_consultant: "",
            RFP_invited: "",
            bid_security: "",
            LOR: "",
            CA_signed: "",
            Appointment_date: "",
            BPC_of_concessionaire: "",
            EPC: "",
            performance_security: "",
            additional_performance_security: "",
            mobilization_advance_after_AD: "",
            approval_of_GAD_of_ROB: "",
            sub_contractor: '',
            consultant: '',
        });
        setErrors({});
    };

    const validateForm = () => {
        const requiredFields = [

            "project_name",


            // "sub_company",

        ];

        const newErrors = {};
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field} is required.`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [fileName, setFileName] = useState("");
    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }
    };

    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            bill: ""
        }));
        setFileName("");
    }
    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }

        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });


    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const toastId = toast.loading("Submitting project...");
        const formDataToSend = new FormData();


        Object.keys(formData).forEach((key) => {
            if (formData[key] && key !== "RFP_invited") {
                formDataToSend.append(key, formData[key]);
            }
        });




        const symbols = "!@#$%^&*()_-+=";
        const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
        const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const now = new Date();
        const date = now
            .toLocaleDateString("en-GB")
            .split("/")
            .reverse()
            .join("-");
        const time = now
            .toLocaleTimeString("en-GB", { hour12: false })
            .replace(/:/g, "-");
        const allChars =
            symbols + lowercaseLetters + uppercaseLetters + numbers;
        let randomCode = "";
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * allChars.length);
            randomCode += allChars[randomIndex];
        }

        const originalFile2 = formData.RFP_invited;
        const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
        const customFile2 = new File([originalFile2], customFileName2, {
            type: originalFile2.type,
        });




        if (formData.RFP_invited) {
            formDataToSend.append("RFP_invited", customFile2);
        }
        try {
            const res = await axios.post(`${BASE_URL}/project_details/project/`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (res.status === 200) {
                toast.success("Project added successfully", { toastId });
                setShow(false);
                await getProjects();
            }
        } catch (error) {
            toast.error("Failed to submit project", { toastId });
        } finally {
            toast.dismiss(toastId);
            setLoading(false);
        }
    };

    const sortedStatesAndUTs = [...IndianStatesAndUTs].sort();


    return (
        <>
            <button
                title="Add Project Details"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> {" "}
                Project
            </button>

            {/* <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model"> */}
            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>Add Project Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            {/* Tender ID */}
                            <div title="Tender ID" className="flex-column">
                                <label htmlFor="tender_id" className="form-labels font-weight500 font-size-subheading">
                                    Tender ID
                                </label>
                                <input
                                    type="text"
                                    id="tender_id"
                                    name="tender_id"
                                    placeholder="Tender ID"
                                    onChange={handleInputChange}
                                    value={formData.tender_id}
                                    className={`form-input-div ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`}
                                />
                                {errors.tender_id && <span className="error-message font-size-text">{errors.tender_id}</span>}
                            </div>

                            {/* Project Code */}


                            {/* Project Short Name */}
                            <div title="Project Short Name" className="flex-column">
                                <label htmlFor="project_short_name" className="form-labels font-weight500 font-size-subheading">
                                    Project   Short Name
                                </label>
                                <input
                                    type="text"
                                    id="project_short_name"
                                    name="project_short_name"
                                    placeholder="Project Short Name"
                                    onChange={handleInputChange}
                                    value={formData.project_short_name}
                                    className={`form-input-div ${errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""
                                        }`}
                                />
                                {errors.project_short_name && (
                                    <span className="error-message font-size-text">{errors.project_short_name}</span>
                                )}
                            </div>

                            {/* Location */}
                            <div title="Location" className="flex-column">
                                <label htmlFor="location" className="form-labels font-weight500 font-size-subheading">
                                    Location (State)
                                </label>
                                <input
                                    type="text"
                                    id="location"
                                    name="location"
                                    placeholder="Location"
                                    onChange={handleInputChange}
                                    value={formData.location}
                                    className={`form-input-div ${errors.location ? "error" : inputState.location ? "success" : ""}`}
                                />
                                {errors.location && <span className="error-message font-size-text">{errors.location}</span>}
                            </div>

                            {/* Project Name */}
                            <div title="Project Name" className="flex-column">
                                <label htmlFor="project_name" className="form-labels font-weight500 font-size-subheading">
                                    Project Name <span className="required">*</span>
                                </label>
                                <textarea
                                    id="project_name"
                                    name="project_name"
                                    placeholder="Project Name"
                                    onChange={handleInputChange}
                                    value={formData.project_name}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.project_name ? "error" : inputState.project_name ? "success" : ""
                                        }`}
                                />
                                {errors.project_name && <div className="error-message font-size-text">{errors.project_name}</div>}
                            </div>

                            <div title="Consultant Name" className="flex-column">
                                <label htmlFor="consultant" className="form-labels font-weight500 font-size-subheading">
                                    Consultant
                                </label>
                                <input
                                    type="text"
                                    id="consultant"
                                    name="consultant"
                                    placeholder="consultant"
                                    onChange={handleInputChange}
                                    value={formData.consultant}
                                    className={`form-input-div ${errors.location ? "error" : inputState.location ? "success" : ""}`}
                                />
                                {errors.consultant && <div className="error-message font-size-text">{errors.consultant}</div>}
                            </div>

                            <div title="Sub Contractor Name" className="flex-column">
                                <label htmlFor="sub_contractor" className="form-labels font-weight500 font-size-subheading">
                                    Sub Contractor
                                </label>
                                <textarea
                                    id="sub_contractor"
                                    name="sub_contractor"
                                    placeholder="Sub Contractor"
                                    onChange={handleInputChange}
                                    value={formData.sub_contractor}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.sub_contractor ? "error" : inputState.sub_contractor ? "success" : ""
                                        }`}
                                />
                                {errors.sub_contractor && <div className="error-message font-size-text">{errors.sub_contractor}</div>}
                            </div>

                            {/* Project Key Points */}
                            <div title="Project Key Points" className="flex-column">
                                <label htmlFor="project_key_point" className="form-labels font-weight500 font-size-subheading">
                                    Project Key Points
                                </label>
                                <textarea
                                    id="project_key_point"
                                    name="project_key_point"
                                    placeholder="Project Key Points"
                                    onChange={handleInputChange}
                                    value={formData.project_key_point}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.project_key_point ? "error" : inputState.project_key_point ? "success" : ""
                                        }`}
                                />
                                {errors.project_key_point && (
                                    <div className="error-message font-size-text">{errors.project_key_point}</div>
                                )}
                            </div>

                            {/* Sub Company */}
                            {/* <div title="Sub Company" className="flex-column">
                                <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                                    Sub Company
                                </label>
                                <select
                                    id="sub_company"
                                    name="sub_company"
                                    placeholder="Sub Company"
                                    value={formData.sub_company}
                                    onChange={handleInputChange}
                                    className={`form-input-div ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select a SubCompany</option>
                                    <option value="location1">Location 1</option>
                                    {siteSubCompanyList
                                        ?.sort((a, b) => a.title.localeCompare(b.title, "en", { ignorePunctuation: true }))
                                        .map((i, index) => (
                                            <option key={index} value={i.id}>{i.title}</option>
                                        ))}
                                </select>
                                {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                            </div> */}

                            {/* Project Length */}
                            <div title="Project Length" className="flex-column">
                                <label htmlFor="project_length" className="form-labels font-weight500 font-size-subheading">
                                    Project Length (in KM)
                                </label>
                                <input
                                    type="text"
                                    id="project_length"
                                    name="project_length"
                                    placeholder="Project Length"
                                    onChange={handleInputChange}
                                    value={formData.project_length}
                                    className={`form-input-div ${errors.project_length ? "error" : inputState.project_length ? "success" : ""
                                        }`}
                                />
                                {errors.project_length && <span className="error-message font-size-text">{errors.project_length}</span>}
                            </div>

                            {/* Bid Due Date */}
                            <div title="Bid Due Date" className="flex-column">
                                <label htmlFor="bid_due_date" className="form-labels font-weight500 font-size-subheading">
                                    Bid Due Date
                                </label>
                                <input
                                    type="date"
                                    id="bid_due_date"
                                    name="bid_due_date"
                                    placeholder="Target Date"
                                    onChange={handleInputChange}
                                    value={formData.bid_due_date}
                                    className={`form-input-div ${errors.bid_due_date ? "error" : inputState.bid_due_date ? "success" : ""
                                        }`}
                                />
                                {errors.bid_due_date && <span className="error-message font-size-text">{errors.bid_due_date}</span>}
                            </div>

                            {/* Agreement Date */}
                            <div title="Agreement Date" className="flex-column">
                                <label htmlFor="agreement_date" className="form-labels font-weight500 font-size-subheading">
                                    Agreement Date
                                </label>
                                <input
                                    type="date"
                                    id="agreement_date"
                                    name="agreement_date"
                                    placeholder="Agreement Date"
                                    onChange={handleInputChange}
                                    value={formData.agreement_date}
                                    className={`form-input-div ${errors.agreement_date ? "error" : inputState.agreement_date ? "success" : ""
                                        }`}
                                />
                                {errors.agreement_date && <span className="error-message font-size-text">{errors.agreement_date}</span>}
                            </div>

                            {/* Commencement Date */}
                            <div title="Commencement Date" className="flex-column">
                                <label htmlFor="commencement_date" className="form-labels font-weight500 font-size-subheading">
                                    Commencement Date
                                </label>
                                <input
                                    type="date"
                                    id="commencement_date"
                                    name="commencement_date"
                                    placeholder="Commencement Date"
                                    onChange={handleInputChange}
                                    value={formData.commencement_date}
                                    className={`form-input-div ${errors.commencement_date ? "error" : inputState.commencement_date ? "success" : ""
                                        }`}
                                />
                                {errors.commencement_date && (
                                    <span className="error-message font-size-text">{errors.commencement_date}</span>
                                )}
                            </div>

                            {/* Project Duration */}
                            <div title="Project Duration" className="flex-column">
                                <label htmlFor="project_duration" className="form-labels font-weight500 font-size-subheading">
                                    Project Duration (In Months)
                                </label>
                                <input
                                    type="text"
                                    id="project_duration"
                                    name="project_duration"
                                    placeholder="Project Duaration"
                                    onChange={handleInputChange}
                                    value={formData.project_duration}
                                    className={`form-input-div ${errors.project_duration ? "error" : inputState.project_duration ? "success" : ""
                                        }`}
                                />
                                {errors.project_duration && (
                                    <span className="error-message font-size-text">{errors.project_duration}</span>
                                )}
                            </div>

                            {/* O&M Duration */}
                            <div title="O&M Duration" className="flex-column">
                                <label htmlFor="om_duration" className="form-labels font-weight500 font-size-subheading">
                                    O & M Duration
                                </label>
                                <input
                                    type="text"
                                    id="om_duration"
                                    name="om_duration"
                                    placeholder="O&M Duaration"
                                    onChange={handleInputChange}
                                    value={formData.om_duration}
                                    className={`form-input-div ${errors.om_duration ? "error" : inputState.om_duration ? "success" : ""}`}
                                />
                                {errors.om_duration && <span className="error-message font-size-text">{errors.om_duration}</span>}
                            </div>

                            {/* Construction Duration */}
                            <div title="Construction Duration" className="flex-column">
                                <label htmlFor="construction_duration" className="form-labels font-weight500 font-size-subheading">
                                    Construction Duration
                                </label>
                                <input
                                    type="text"
                                    id="construction_duration"
                                    name="construction_duration"
                                    placeholder="Project Duaration"
                                    onChange={handleInputChange}
                                    value={formData.construction_duration}
                                    className={`form-input-div ${errors.construction_duration ? "error" : inputState.construction_duration ? "success" : ""
                                        }`}
                                />
                                {errors.construction_duration && (
                                    <span className="error-message font-size-text">{errors.construction_duration}</span>
                                )}
                            </div>

                            {/* Project Completion Date */}
                            <div title="Project Completion Date" className="flex-column">
                                <label htmlFor="project_completion_date" className="form-labels font-weight500 font-size-subheading">
                                    Project Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="project_completion_date"
                                    name="project_completion_date"
                                    placeholder="Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.project_completion_date}
                                    className={`form-input-div ${errors.project_completion_date ? "error" : inputState.project_completion_date ? "success" : ""
                                        }`}
                                />
                                {errors.project_completion_date && (
                                    <span className="error-message font-size-text">{errors.project_completion_date}</span>
                                )}
                            </div>

                            {/* Remark */}


                            {/* Project Cost Replace */}
                            <div title="Project Cost Replace" className="flex-column">
                                <label htmlFor="project_cost_replace" className="form-labels font-weight500 font-size-subheading">
                                    Project Cost
                                </label>
                                <input
                                    type="text"
                                    id="project_cost_replace"
                                    name="project_cost_replace"
                                    placeholder="Project Cost"
                                    onChange={handleInputChange}
                                    value={formData.project_cost_replace}
                                    className={`form-input-div ${errors.project_cost_replace ? "error" : inputState.project_cost_replace ? "success" : ""
                                        }`}
                                />
                                {errors.project_cost_replace && <span className="error-message font-size-text">{errors.project_cost_replace}</span>}
                            </div>

                            {/* Contract Mode */}
                            <div title="Contract Mode" className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Contract Mode
                                </label>
                                <select
                                    name="contract_mode"
                                    onChange={handleInputChange}
                                    value={formData.contract_mode}
                                    className={`form-input-div ${errors.contract_mode ? "error" : inputState.contract_mode ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Contract Mode </option>
                                    <option value="epc">EPC </option>
                                    <option value="ham"> HAM</option>
                                    <option value="bot">BOT </option>
                                </select>
                                {errors.contract_mode && <span className="error-message font-size-text">{errors.contract_mode}</span>}
                            </div>


                            {/* Regional Office Name */}
                            <div title="Regional Office Name" className="flex-column">
                                <label htmlFor="ro" className="form-labels font-weight500 font-size-subheading">
                                    Regional Office Name (RO Name)
                                </label>
                                <input
                                    type="text"
                                    id="ro"
                                    name="ro"
                                    placeholder="Regional Office Name"
                                    onChange={handleInputChange}
                                    value={formData.ro}
                                    className={`form-input-div ${errors.ro ? "error" : inputState.ro ? "success" : ""}`}
                                />
                                {errors.ro && <span className="error-message font-size-text">{errors.ro}</span>}
                            </div>

                            {/* Regional Office Address */}
                            <div title="Regional Office Address (RO Address)" className="flex-column">
                                <label htmlFor="ro_address" className="form-labels font-weight500 font-size-subheading">
                                    Regional Office Address (RO Address)
                                </label>
                                <textarea
                                    id="ro_address"
                                    name="ro_address"
                                    placeholder="Regional Office Address"
                                    onChange={handleInputChange}
                                    value={formData.ro_address}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.ro_address ? "error" : inputState.ro_address ? "success" : ""
                                        }`}
                                />
                                {errors.ro_address && <div className="error-message font-size-text">{errors.ro_address}</div>}
                            </div>

                            {/* PIU Address */}
                            <div title="PIU Address" className="flex-column">
                                <label htmlFor="piu_address" className="form-labels font-weight500 font-size-subheading">
                                    PIU Address
                                </label>
                                <textarea
                                    id="piu_address"
                                    name="piu_address"
                                    placeholder="PIU Address"
                                    onChange={handleInputChange}
                                    value={formData.piu_address}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.piu_address ? "error" : inputState.piu_address ? "success" : ""
                                        }`}
                                />
                                {errors.piu_address && <div className="error-message font-size-text">{errors.piu_address}</div>}
                            </div>

                            {/* Client Name */}
                            <div title="Client Name" className="flex-column">
                                <label htmlFor="client_name" className="form-labels font-weight500 font-size-subheading">
                                    Client Name
                                </label>
                                <input
                                    type="text"
                                    id="client_name"
                                    name="client_name"
                                    placeholder="Client Name"
                                    onChange={handleInputChange}
                                    value={formData.client_name}
                                    className={`form-input-div ${errors.client_name ? "error" : inputState.client_name ? "success" : ""
                                        }`}
                                />
                                {errors.client_name && <span className="error-message font-size-text">{errors.client_name}</span>}
                            </div>

                            {/* Concern Person Name */}
                            <div title="Concern Person Name" className="flex-column">
                                <label htmlFor="concern_person_name" className="form-labels font-weight500 font-size-subheading">
                                    Concern Person Name
                                </label>
                                <input
                                    type="text"
                                    id="concern_person_name"
                                    name="concern_person_name"
                                    placeholder="Concern Person Name"
                                    onChange={handleInputChange}
                                    value={formData.concern_person_name}
                                    className={`form-input-div ${errors.concern_person_name ? "error" : inputState.concern_person_name ? "success" : ""
                                        }`}
                                />
                                {errors.concern_person_name && (
                                    <span className="error-message font-size-text">{errors.concern_person_name}</span>
                                )}
                            </div>
                            <div title="Notice Invite Tender ID" className="flex-column">
                                <label htmlFor="notice_intivite_tender_id" className="form-labels font-weight500 font-size-subheading">
                                    Notice Invite Tender Document
                                </label>
                                <input
                                    type="text"
                                    id="notice_intivite_tender_id"
                                    name="notice_intivite_tender_id"
                                    onChange={handleInputChange}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project Mode */}
                            <div title="Project Mode" className="flex-column">
                                <label htmlFor="project_mode" className="form-labels font-weight500 font-size-subheading">
                                    Project Mode
                                </label>
                                <input
                                    type="text"
                                    id="project_mode"
                                    name="project_mode"
                                    placeholder="Project Mode"
                                    onChange={handleInputChange}
                                    value={formData.project_mode}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project Form */}
                            <div title="Project Form" className="flex-column">
                                <label htmlFor="project_form" className="form-labels font-weight500 font-size-subheading">
                                    Project Form
                                </label>
                                <input
                                    type="text"
                                    id="project_form"
                                    name="project_form"
                                    placeholder="Project Form"
                                    onChange={handleInputChange}
                                    value={formData.project_form}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project To */}
                            <div title="Project To" className="flex-column">
                                <label htmlFor="project_to" className="form-labels font-weight500 font-size-subheading">
                                    Project To
                                </label>
                                <input
                                    type="text"
                                    id="project_to"
                                    name="project_to"
                                    placeholder="Project To"
                                    onChange={handleInputChange}
                                    value={formData.project_to}
                                    className="form-input-div"
                                />
                            </div>

                            {/* SPV */}
                            <div title="SPV" className="flex-column">
                                <label htmlFor="spv" className="form-labels font-weight500 font-size-subheading">
                                    SPV
                                </label>
                                <input
                                    type="text"
                                    id="spv"
                                    name="spv"
                                    placeholder="SPV"
                                    onChange={handleInputChange}
                                    value={formData.spv}
                                    className="form-input-div"
                                />
                            </div>

                            {/* NH No */}
                            <div title="NH No" className="flex-column">
                                <label htmlFor="nh_no" className="form-labels font-weight500 font-size-subheading">
                                    NH No
                                </label>
                                <input
                                    type="text"
                                    id="nh_no"
                                    name="nh_no"
                                    placeholder="NH No"
                                    onChange={handleInputChange}
                                    value={formData.nh_no}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Name of DPR Consultant */}
                            <div title="Name of DPR Consultant" className="flex-column">
                                <label htmlFor="name_of_dpr_consultant" className="form-labels font-weight500 font-size-subheading">
                                    Name of DPR Consultant
                                </label>
                                <input
                                    type="text"
                                    id="name_of_dpr_consultant"
                                    name="name_of_dpr_consultant"
                                    placeholder="Name of DPR Consultant"
                                    onChange={handleInputChange}
                                    value={formData.name_of_dpr_consultant}
                                    className="form-input-div"
                                />
                            </div>

                            {/* RFP Invited */}
                            <div title="RFP Invited" className="flex-column">
                                <label htmlFor="RFP_invited" className="form-labels font-weight500 font-size-subheading">
                                    RFP Invited
                                </label>
                                <input
                                    type="file"
                                    id="RFP_invited"
                                    name="RFP_invited"
                                    placeholder="RFP Invited"
                                    onChange={handleInputChange}
                                    // value={formData.RFP_invited}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Bid Security */}
                            <div title="Bid Security" className="flex-column">
                                <label htmlFor="bid_security" className="form-labels font-weight500 font-size-subheading">
                                    Bid Security
                                </label>
                                <input
                                    type="text"
                                    id="bid_security"
                                    name="bid_security"
                                    placeholder="Bid Security"
                                    onChange={handleInputChange}
                                    value={formData.bid_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* LOR */}
                            <div title="LOR" className="flex-column">
                                <label htmlFor="LOR" className="form-labels font-weight500 font-size-subheading">
                                    LOR
                                </label>
                                <input
                                    type="text"
                                    id="LOR"
                                    name="LOR"
                                    placeholder="LOR"
                                    onChange={handleInputChange}
                                    value={formData.LOR}
                                    className="form-input-div"
                                />
                            </div>

                            {/* CA Signed */}
                            <div title="CA Signed" className="flex-column">
                                <label htmlFor="CA_signed" className="form-labels font-weight500 font-size-subheading">
                                    CA Signed
                                </label>
                                <input
                                    type="text"
                                    id="CA_signed"
                                    name="CA_signed"
                                    placeholder="CA Signed"
                                    onChange={handleInputChange}
                                    value={formData.CA_signed}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Appointment Date */}
                            <div title="Appointment Date" className="flex-column">
                                <label htmlFor="Appointment_date" className="form-labels font-weight500 font-size-subheading">
                                    Appointment Date
                                </label>
                                <input
                                    type="date"
                                    id="Appointment_date"
                                    name="Appointment_date"
                                    placeholder="Appointment Date"
                                    onChange={handleInputChange}
                                    value={formData.Appointment_date}
                                    className="form-input-div"
                                />
                            </div>

                            {/* BPC of Concessionaire */}
                            <div title="BPC of Concessionaire" className="flex-column">
                                <label htmlFor="BPC_of_concessionaire" className="form-labels font-weight500 font-size-subheading">
                                    BPC of Concessionaire
                                </label>
                                <input
                                    type="text"
                                    id="BPC_of_concessionaire"
                                    name="BPC_of_concessionaire"
                                    placeholder="BPC of Concessionaire"
                                    onChange={handleInputChange}
                                    value={formData.BPC_of_concessionaire}
                                    className="form-input-div"
                                />
                            </div>

                            {/* EPC */}
                            <div title="EPC" className="flex-column">
                                <label htmlFor="EPC" className="form-labels font-weight500 font-size-subheading">
                                    EPC
                                </label>
                                <input
                                    type="text"
                                    id="EPC"
                                    name="EPC"
                                    placeholder="EPC"
                                    onChange={handleInputChange}
                                    value={formData.EPC}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Performance Security */}
                            <div title="Performance Security" className="flex-column">
                                <label htmlFor="performance_security" className="form-labels font-weight500 font-size-subheading">
                                    Performance Security
                                </label>
                                <input
                                    type="text"
                                    id="performance_security"
                                    name="performance_security"
                                    placeholder="Performance Security"
                                    onChange={handleInputChange}
                                    value={formData.performance_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Additional Performance Security */}
                            <div title="Additional Performance Security" className="flex-column">
                                <label htmlFor="additional_performance_security" className="form-labels font-weight500 font-size-subheading">
                                    Additional Performance Security
                                </label>
                                <input
                                    type="text"
                                    id="additional_performance_security"
                                    name="additional_performance_security"
                                    placeholder="Additional Performance Security"
                                    onChange={handleInputChange}
                                    value={formData.additional_performance_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Mobilization Advance After AD */}
                            <div title="Mobilization Advance After AD" className="flex-column">
                                <label htmlFor="mobilization_advance_after_AD" className="form-labels font-weight500 font-size-subheading">
                                    Mobilization Advance After AD
                                </label>
                                <input
                                    type="text"
                                    id="mobilization_advance_after_AD"
                                    name="mobilization_advance_after_AD"
                                    placeholder="Mobilization Advance After AD"
                                    onChange={handleInputChange}
                                    value={formData.mobilization_advance_after_AD}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Approval of GAD of ROB */}
                            <div title="Approval of GAD of ROB" className="flex-column">
                                <label htmlFor="approval_of_GAD_of_ROB" className="form-labels font-weight500 font-size-subheading">
                                    Approval of GAD of ROB
                                </label>
                                <input
                                    type="text"
                                    id="approval_of_GAD_of_ROB"
                                    name="approval_of_GAD_of_ROB"
                                    placeholder="Approval of GAD of ROB"
                                    onChange={handleInputChange}
                                    value={formData.approval_of_GAD_of_ROB}
                                    className="form-input-div"
                                />
                            </div>
                        </div>

                        {/* Form Buttons */}
                        <div className="button-models justifycontentimportant" style={{ gap: "24px" }}>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button font-weight500 model-button-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleFormSubmit}
                                className="model-button font-weight500 model-button-submit"
                                disabled={loading}
                            >
                                Submit
                            </button>
                        </div>

                        {/* Error Message */}
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </form>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateProjectAllDetails = ({ i, getProjects, siteSubCompanyList }) => {
    const [show, setShow] = useState(false);
    const uniqueStreamTypes = new Set();

    const handleShow = () => {
        getAllEmp_code();
        console.log(i, 'data')
        setFormData(i);
        setShow(true);
        clientList.forEach(entry => {
            uniqueStreamTypes.add(entry.client_name);
        });
    };
    const [clientList, setClientList] = useState([]);

    const [empList, setEmpList] = useState([]);

    const handleClose = () => {
        getProjects();
        setErrors({});
        setShow(false);
    };

    const [buffer, setBuffering] = useState(false); //buffering logic

    const [formData, setFormData] = useState({

        project_name: "",
        project_short_name: "",
        location: "",
        concern_person_name: "",
        tender_id: "",
        project_length: "",
        ro: "",
        ro_address: "",
        piu_address: "",
        agreement_date: null,
        commencement_date: null,
        project_duration: "",
        om_duration: "",
        construction_duration: "",
        client_name: "",
        project_completion_date: null,
        bid_due_date: null,

        project_key_point: "",
        project_cost_replace: "",
        contract_mode: "",
        status: "",
        sub_company: "",
        admin_approval_for_dlt: false,
        req_raised_by_AE: "",
        esclation: "",
        is_escalation_added: false,
        our_services: "",

        notice_intivite_tender_id: "",
        project_mode: "",
        project_form: "",
        project_to: "",
        spv: "",
        nh_no: "",
        name_of_dpr_consultant: "",
        RFP_invited: "",
        bid_security: "",
        LOR: "",
        CA_signed: "",
        Appointment_date: "",
        BPC_of_concessionaire: "",
        EPC: "",
        performance_security: "",
        additional_performance_security: "",
        mobilization_advance_after_AD: "",
        approval_of_GAD_of_ROB: "",
        sub_contractor: '',
        consultant: '',
    });

    const getAllEmp_code = async (toggleCompany) => {
        setBuffering(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/manpower/getemprole/`
            );

            const getAlphaNumericParts = (code) => {
                const match = code.match(/^([A-Za-z]+)(\d+)$/); // Match alphabetic and numeric parts
                if (match) {
                    return { alphaPart: match[1], numericPart: parseInt(match[2], 10) };
                } else {
                    return { alphaPart: "", numericPart: 0 };
                }
            };

            const sortedList = res.data.sort((a, b) => {
                const { alphaPart: alphaA, numericPart: numericA } =
                    getAlphaNumericParts(a.emp_code);
                const { alphaPart: alphaB, numericPart: numericB } =
                    getAlphaNumericParts(b.emp_code);

                if (alphaA !== alphaB) {
                    return alphaA.localeCompare(alphaB); // Sort alphabetically
                } else {
                    return numericA - numericB; // Then sort numerically
                }
            });
            setEmpList(sortedList);
            // setEmp_code(res.data);

            const cli = await axios.get(`${BASE_URL}/project_details/project-clients/`);
            setClientList(cli.data);
        } catch (err) {
            // alert(err.message);
        } finally {
            setBuffering(false);
        }
    };


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            "project_name",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        toast.warning(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const [fileName, setFileName] = useState("");
    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }
    };

    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            bill: ""
        }));
        setFileName("");
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }

        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });


    };



    // ?  ************** Validation End **************  ! //

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); //loading logic

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/project_details/project/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    setShow(false);
                    await getProjects();
                    toast.success("Upadate Project Details Successfully.");
                    toast.dismiss(loadingToastId);

                } else {
                    // alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Update All Project Details"
                style={{ margin: 0 }}
                className="upload-svg update-button-size"
                onClick={handleShow}
            >
                <UpdatePencilWhite />{" "}
                Update Details
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Project  Details </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-form">
                        <div className="form-flex-wrap">
                            {/* Tender ID */}
                            <div title="Tender ID" className="flex-column">
                                <label htmlFor="tender_id" className="form-labels font-weight500 font-size-subheading">
                                    Tender ID
                                </label>
                                <input
                                    type="text"
                                    id="tender_id"
                                    name="tender_id"
                                    placeholder="Tender ID"
                                    onChange={handleInputChange}
                                    value={formData.tender_id}
                                    className={`form-input-div ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`}
                                />
                                {errors.tender_id && <span className="error-message font-size-text">{errors.tender_id}</span>}
                            </div>



                            {/* Project Short Name */}
                            <div title="Project Short Name" className="flex-column">
                                <label htmlFor="project_short_name" className="form-labels font-weight500 font-size-subheading">
                                    Project Short Name
                                </label>
                                <input
                                    type="text"
                                    id="project_short_name"
                                    name="project_short_name"
                                    placeholder="Project Short Name"
                                    onChange={handleInputChange}
                                    value={formData.project_short_name}
                                    className={`form-input-div ${errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""
                                        }`}
                                />
                                {errors.project_short_name && (
                                    <span className="error-message font-size-text">{errors.project_short_name}</span>
                                )}
                            </div>

                            {/* Location */}
                            <div title="Location" className="flex-column">
                                <label htmlFor="location" className="form-labels font-weight500 font-size-subheading">
                                    Location (State)
                                </label>
                                <input
                                    type="text"
                                    id="location"
                                    name="location"
                                    placeholder="Location"
                                    onChange={handleInputChange}
                                    value={formData.location}
                                    className={`form-input-div ${errors.location ? "error" : inputState.location ? "success" : ""}`}
                                />
                                {errors.location && <span className="error-message font-size-text">{errors.location}</span>}
                            </div>

                            {/* Project Name */}
                            <div title="Project Name" className="flex-column">
                                <label htmlFor="project_name" className="form-labels font-weight500 font-size-subheading">
                                    Project Name <span className="required">*</span>
                                </label>
                                <textarea
                                    id="project_name"
                                    name="project_name"
                                    placeholder="Project Name"
                                    onChange={handleInputChange}
                                    value={formData.project_name}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.project_name ? "error" : inputState.project_name ? "success" : ""
                                        }`}
                                />
                                {errors.project_name && <div className="error-message font-size-text">{errors.project_name}</div>}
                            </div>

                            <div title="Project Name" className="flex-column">
                                <label htmlFor="project_name" className="form-labels font-weight500 font-size-subheading">
                                    Project Name <span className="required">*</span>
                                </label>
                                <textarea
                                    id="project_name"
                                    name="project_name"
                                    placeholder="Project Name"
                                    onChange={handleInputChange}
                                    value={formData.project_name}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.project_name ? "error" : inputState.project_name ? "success" : ""
                                        }`}
                                />
                                {errors.project_name && <div className="error-message font-size-text">{errors.project_name}</div>}
                            </div>

                            <div title="Consultant Name" className="flex-column">
                                <label htmlFor="consultant" className="form-labels font-weight500 font-size-subheading">
                                    Consultant
                                </label>
                                <input
                                    type="text"
                                    id="consultant"
                                    name="consultant"
                                    placeholder="consultant"
                                    onChange={handleInputChange}
                                    value={formData.consultant}
                                    className={`form-input-div ${errors.location ? "error" : inputState.location ? "success" : ""}`}
                                />
                                {errors.consultant && <div className="error-message font-size-text">{errors.consultant}</div>}
                            </div>

                            {/* Project Key Points */}
                            <div title="Project Key Points" className="flex-column">
                                <label htmlFor="project_key_point" className="form-labels font-weight500 font-size-subheading">
                                    Project Key Points
                                </label>
                                <textarea
                                    id="project_key_point"
                                    name="project_key_point"
                                    placeholder="Project Key Points"
                                    onChange={handleInputChange}
                                    value={formData.project_key_point}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.project_key_point ? "error" : inputState.project_key_point ? "success" : ""
                                        }`}
                                />
                                {errors.project_key_point && (
                                    <div className="error-message font-size-text">{errors.project_key_point}</div>
                                )}
                            </div>

                            {/* Sub Company */}
                            {/* <div title="Sub Company" className="flex-column">
                                <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                                    Sub Company
                                </label>
                                <select
                                    id="sub_company"
                                    name="sub_company"
                                    placeholder="Sub Company"
                                    value={formData.sub_company}
                                    onChange={handleInputChange}
                                    className={`form-input-div ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select a SubCompany</option>
                                    <option value="location1">Location 1</option>
                                    {siteSubCompanyList
                                        ?.sort((a, b) => a.title.localeCompare(b.title, "en", { ignorePunctuation: true }))
                                        .map((i, index) => (
                                            <option key={index} value={i.id}>{i.title}</option>
                                        ))}
                                </select>
                                {errors.sub_company && <span className="error-message font-size-text">{errors.sub_company}</span>}
                            </div> */}

                            {/* Work Type */}




                            {/* Project Length */}
                            <div title="Project Length" className="flex-column">
                                <label htmlFor="project_length" className="form-labels font-weight500 font-size-subheading">
                                    Project Length (in KM)
                                </label>
                                <input
                                    type="text"
                                    id="project_length"
                                    name="project_length"
                                    placeholder="Project Length"
                                    onChange={handleInputChange}
                                    value={formData.project_length}
                                    className={`form-input-div ${errors.project_length ? "error" : inputState.project_length ? "success" : ""
                                        }`}
                                />
                                {errors.project_length && <span className="error-message font-size-text">{errors.project_length}</span>}
                            </div>

                            {/* Bid Due Date */}
                            <div title="Bid Due Date" className="flex-column">
                                <label htmlFor="bid_due_date" className="form-labels font-weight500 font-size-subheading">
                                    Bid Due Date
                                </label>
                                <input
                                    type="date"
                                    id="bid_due_date"
                                    name="bid_due_date"
                                    placeholder="Target Date"
                                    onChange={handleInputChange}
                                    value={formData.bid_due_date}
                                    className={`form-input-div ${errors.bid_due_date ? "error" : inputState.bid_due_date ? "success" : ""
                                        }`}
                                />
                                {errors.bid_due_date && <span className="error-message font-size-text">{errors.bid_due_date}</span>}
                            </div>

                            {/* Agreement Date */}
                            <div title="Agreement Date" className="flex-column">
                                <label htmlFor="agreement_date" className="form-labels font-weight500 font-size-subheading">
                                    Agreement Date
                                </label>
                                <input
                                    type="date"
                                    id="agreement_date"
                                    name="agreement_date"
                                    placeholder="Agreement Date"
                                    onChange={handleInputChange}
                                    value={formData.agreement_date}
                                    className={`form-input-div ${errors.agreement_date ? "error" : inputState.agreement_date ? "success" : ""
                                        }`}
                                />
                                {errors.agreement_date && <span className="error-message font-size-text">{errors.agreement_date}</span>}
                            </div>

                            {/* Commencement Date */}
                            <div title="Commencement Date" className="flex-column">
                                <label htmlFor="commencement_date" className="form-labels font-weight500 font-size-subheading">
                                    Commencement Date
                                </label>
                                <input
                                    type="date"
                                    id="commencement_date"
                                    name="commencement_date"
                                    placeholder="Commencement Date"
                                    onChange={handleInputChange}
                                    value={formData.commencement_date}
                                    className={`form-input-div ${errors.commencement_date ? "error" : inputState.commencement_date ? "success" : ""
                                        }`}
                                />
                                {errors.commencement_date && (
                                    <span className="error-message font-size-text">{errors.commencement_date}</span>
                                )}
                            </div>

                            {/* Project Duration */}
                            <div title="Project Duration" className="flex-column">
                                <label htmlFor="project_duration" className="form-labels font-weight500 font-size-subheading">
                                    Project Duration (In Months)
                                </label>
                                <input
                                    type="text"
                                    id="project_duration"
                                    name="project_duration"
                                    placeholder="Project Duaration"
                                    onChange={handleInputChange}
                                    value={formData.project_duration}
                                    className={`form-input-div ${errors.project_duration ? "error" : inputState.project_duration ? "success" : ""
                                        }`}
                                />
                                {errors.project_duration && (
                                    <span className="error-message font-size-text">{errors.project_duration}</span>
                                )}
                            </div>

                            {/* O&M Duration */}
                            <div title="O&M Duration" className="flex-column">
                                <label htmlFor="om_duration" className="form-labels font-weight500 font-size-subheading">
                                    O & M Duration
                                </label>
                                <input
                                    type="text"
                                    id="om_duration"
                                    name="om_duration"
                                    placeholder="O&M Duaration"
                                    onChange={handleInputChange}
                                    value={formData.om_duration}
                                    className={`form-input-div ${errors.om_duration ? "error" : inputState.om_duration ? "success" : ""}`}
                                />
                                {errors.om_duration && <span className="error-message font-size-text">{errors.om_duration}</span>}
                            </div>

                            {/* Construction Duration */}
                            <div title="Construction Duration" className="flex-column">
                                <label htmlFor="construction_duration" className="form-labels font-weight500 font-size-subheading">
                                    Construction Duration
                                </label>
                                <input
                                    type="text"
                                    id="construction_duration"
                                    name="construction_duration"
                                    placeholder="Project Duaration"
                                    onChange={handleInputChange}
                                    value={formData.construction_duration}
                                    className={`form-input-div ${errors.construction_duration ? "error" : inputState.construction_duration ? "success" : ""
                                        }`}
                                />
                                {errors.construction_duration && (
                                    <span className="error-message font-size-text">{errors.construction_duration}</span>
                                )}
                            </div>

                            {/* Project Completion Date */}
                            <div title="Project Completion Date" className="flex-column">
                                <label htmlFor="project_completion_date" className="form-labels font-weight500 font-size-subheading">
                                    Project Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="project_completion_date"
                                    name="project_completion_date"
                                    placeholder="Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.project_completion_date}
                                    className={`form-input-div ${errors.project_completion_date ? "error" : inputState.project_completion_date ? "success" : ""
                                        }`}
                                />
                                {errors.project_completion_date && (
                                    <span className="error-message font-size-text">{errors.project_completion_date}</span>
                                )}
                            </div>

                            {/* Remark */}


                            {/* Project Cost Replace */}
                            <div title="Project Cost Replace" className="flex-column">
                                <label htmlFor="project_cost_replace" className="form-labels font-weight500 font-size-subheading">
                                    Project Cost
                                </label>
                                <input
                                    type="text"
                                    id="project_cost_replace"
                                    name="project_cost_replace"
                                    placeholder="Project Cost"
                                    onChange={handleInputChange}
                                    value={formData.project_cost_replace}
                                    className={`form-input-div ${errors.project_cost_replace ? "error" : inputState.project_cost_replace ? "success" : ""
                                        }`}
                                />
                                {errors.project_cost_replace && <span className="error-message font-size-text">{errors.project_cost_replace}</span>}
                            </div>

                            {/* Contract Mode */}
                            <div title="Contract Mode" className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Contract Mode
                                </label>
                                <select
                                    name="contract_mode"
                                    onChange={handleInputChange}
                                    value={formData.contract_mode}
                                    className={`form-input-div ${errors.contract_mode ? "error" : inputState.contract_mode ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Contract Mode </option>
                                    <option value="epc">EPC </option>
                                    <option value="ham"> HAM</option>
                                    <option value="bot">BOT </option>
                                </select>
                                {errors.contract_mode && <span className="error-message font-size-text">{errors.contract_mode}</span>}
                            </div>


                            {/* Regional Office Name */}
                            <div title="Regional Office Name" className="flex-column">
                                <label htmlFor="ro" className="form-labels font-weight500 font-size-subheading">
                                    Regional Office Name (RO Name)
                                </label>
                                <input
                                    type="text"
                                    id="ro"
                                    name="ro"
                                    placeholder="Regional Office Name"
                                    onChange={handleInputChange}
                                    value={formData.ro}
                                    className={`form-input-div ${errors.ro ? "error" : inputState.ro ? "success" : ""}`}
                                />
                                {errors.ro && <span className="error-message font-size-text">{errors.ro}</span>}
                            </div>

                            {/* Regional Office Address */}
                            <div title="Regional Office Address (RO Address)" className="flex-column">
                                <label htmlFor="ro_address" className="form-labels font-weight500 font-size-subheading">
                                    Regional Office Address (RO Address)
                                </label>
                                <textarea
                                    id="ro_address"
                                    name="ro_address"
                                    placeholder="Regional Office Address"
                                    onChange={handleInputChange}
                                    value={formData.ro_address}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.ro_address ? "error" : inputState.ro_address ? "success" : ""
                                        }`}
                                />
                                {errors.ro_address && <div className="error-message font-size-text">{errors.ro_address}</div>}
                            </div>

                            {/* PIU Address */}
                            <div title="PIU Address" className="flex-column">
                                <label htmlFor="piu_address" className="form-labels font-weight500 font-size-subheading">
                                    PIU Address
                                </label>
                                <textarea
                                    id="piu_address"
                                    name="piu_address"
                                    placeholder="PIU Address"
                                    onChange={handleInputChange}
                                    value={formData.piu_address}
                                    rows={4}
                                    className={`form-textarea form-input-div ${errors.piu_address ? "error" : inputState.piu_address ? "success" : ""
                                        }`}
                                />
                                {errors.piu_address && <div className="error-message font-size-text">{errors.piu_address}</div>}
                            </div>

                            {/* Client Name */}
                            <div title="Client Name" className="flex-column">
                                <label htmlFor="client_name" className="form-labels font-weight500 font-size-subheading">
                                    Client Name
                                </label>
                                <input
                                    type="text"
                                    id="client_name"
                                    name="client_name"
                                    placeholder="Client Name"
                                    onChange={handleInputChange}
                                    value={formData.client_name}
                                    className={`form-input-div ${errors.client_name ? "error" : inputState.client_name ? "success" : ""
                                        }`}
                                />
                                {errors.client_name && <span className="error-message font-size-text">{errors.client_name}</span>}
                            </div>

                            {/* Concern Person Name */}
                            <div title="Concern Person Name" className="flex-column">
                                <label htmlFor="concern_person_name" className="form-labels font-weight500 font-size-subheading">
                                    Concern Person Name
                                </label>
                                <input
                                    type="text"
                                    id="concern_person_name"
                                    name="concern_person_name"
                                    placeholder="Concern Person Name"
                                    onChange={handleInputChange}
                                    value={formData.concern_person_name}
                                    className={`form-input-div ${errors.concern_person_name ? "error" : inputState.concern_person_name ? "success" : ""
                                        }`}
                                />
                                {errors.concern_person_name && (
                                    <span className="error-message font-size-text">{errors.concern_person_name}</span>
                                )}
                            </div>
                            <div title="Notice Invite Tender ID" className="flex-column">
                                <label htmlFor="notice_intivite_tender_id" className="form-labels font-weight500 font-size-subheading">
                                    Notice Invite Tender Document
                                </label>
                                <input
                                    type="text"
                                    id="notice_intivite_tender_id"
                                    name="notice_intivite_tender_id"
                                    onChange={handleInputChange}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project Mode */}
                            <div title="Project Mode" className="flex-column">
                                <label htmlFor="project_mode" className="form-labels font-weight500 font-size-subheading">
                                    Project Mode
                                </label>
                                <input
                                    type="text"
                                    id="project_mode"
                                    name="project_mode"
                                    placeholder="Project Mode"
                                    onChange={handleInputChange}
                                    value={formData.project_mode}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project Form */}
                            <div title="Project Form" className="flex-column">
                                <label htmlFor="project_form" className="form-labels font-weight500 font-size-subheading">
                                    Project Form
                                </label>
                                <input
                                    type="text"
                                    id="project_form"
                                    name="project_form"
                                    placeholder="Project Form"
                                    onChange={handleInputChange}
                                    value={formData.project_form}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Project To */}
                            <div title="Project To" className="flex-column">
                                <label htmlFor="project_to" className="form-labels font-weight500 font-size-subheading">
                                    Project To
                                </label>
                                <input
                                    type="text"
                                    id="project_to"
                                    name="project_to"
                                    placeholder="Project To"
                                    onChange={handleInputChange}
                                    value={formData.project_to}
                                    className="form-input-div"
                                />
                            </div>

                            {/* SPV */}
                            <div title="SPV" className="flex-column">
                                <label htmlFor="spv" className="form-labels font-weight500 font-size-subheading">
                                    SPV
                                </label>
                                <input
                                    type="text"
                                    id="spv"
                                    name="spv"
                                    placeholder="SPV"
                                    onChange={handleInputChange}
                                    value={formData.spv}
                                    className="form-input-div"
                                />
                            </div>

                            {/* NH No */}
                            <div title="NH No" className="flex-column">
                                <label htmlFor="nh_no" className="form-labels font-weight500 font-size-subheading">
                                    NH No
                                </label>
                                <input
                                    type="text"
                                    id="nh_no"
                                    name="nh_no"
                                    placeholder="NH No"
                                    onChange={handleInputChange}
                                    value={formData.nh_no}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Name of DPR Consultant */}
                            <div title="Name of DPR Consultant" className="flex-column">
                                <label htmlFor="name_of_dpr_consultant" className="form-labels font-weight500 font-size-subheading">
                                    Name of DPR Consultant
                                </label>
                                <input
                                    type="text"
                                    id="name_of_dpr_consultant"
                                    name="name_of_dpr_consultant"
                                    placeholder="Name of DPR Consultant"
                                    onChange={handleInputChange}
                                    value={formData.name_of_dpr_consultant}
                                    className="form-input-div"
                                />
                            </div>

                            {/* RFP Invited */}
                            <div title="RFP Invited" className="flex-column">
                                <label htmlFor="RFP_invited" className="form-labels font-weight500 font-size-subheading">
                                    RFP Invited
                                </label>
                                <input
                                    type="file"
                                    id="RFP_invited"
                                    name="RFP_invited"
                                    placeholder="RFP Invited"
                                    onChange={handleInputChange}
                                    value={formData.RFP_invited}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Bid Security */}
                            <div title="Bid Security" className="flex-column">
                                <label htmlFor="bid_security" className="form-labels font-weight500 font-size-subheading">
                                    Bid Security
                                </label>
                                <input
                                    type="text"
                                    id="bid_security"
                                    name="bid_security"
                                    placeholder="Bid Security"
                                    onChange={handleInputChange}
                                    value={formData.bid_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* LOR */}
                            <div title="LOR" className="flex-column">
                                <label htmlFor="LOR" className="form-labels font-weight500 font-size-subheading">
                                    LOR
                                </label>
                                <input
                                    type="text"
                                    id="LOR"
                                    name="LOR"
                                    placeholder="LOR"
                                    onChange={handleInputChange}
                                    value={formData.LOR}
                                    className="form-input-div"
                                />
                            </div>

                            {/* CA Signed */}
                            <div title="CA Signed" className="flex-column">
                                <label htmlFor="CA_signed" className="form-labels font-weight500 font-size-subheading">
                                    CA Signed
                                </label>
                                <input
                                    type="text"
                                    id="CA_signed"
                                    name="CA_signed"
                                    placeholder="CA Signed"
                                    onChange={handleInputChange}
                                    value={formData.CA_signed}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Appointment Date */}
                            <div title="Appointment Date" className="flex-column">
                                <label htmlFor="Appointment_date" className="form-labels font-weight500 font-size-subheading">
                                    Appointment Date
                                </label>
                                <input
                                    type="date"
                                    id="Appointment_date"
                                    name="Appointment_date"
                                    placeholder="Appointment Date"
                                    onChange={handleInputChange}
                                    value={formData.Appointment_date}
                                    className="form-input-div"
                                />
                            </div>

                            {/* BPC of Concessionaire */}
                            <div title="BPC of Concessionaire" className="flex-column">
                                <label htmlFor="BPC_of_concessionaire" className="form-labels font-weight500 font-size-subheading">
                                    BPC of Concessionaire
                                </label>
                                <input
                                    type="text"
                                    id="BPC_of_concessionaire"
                                    name="BPC_of_concessionaire"
                                    placeholder="BPC of Concessionaire"
                                    onChange={handleInputChange}
                                    value={formData.BPC_of_concessionaire}
                                    className="form-input-div"
                                />
                            </div>

                            {/* EPC */}
                            <div title="EPC" className="flex-column">
                                <label htmlFor="EPC" className="form-labels font-weight500 font-size-subheading">
                                    EPC
                                </label>
                                <input
                                    type="text"
                                    id="EPC"
                                    name="EPC"
                                    placeholder="EPC"
                                    onChange={handleInputChange}
                                    value={formData.EPC}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Performance Security */}
                            <div title="Performance Security" className="flex-column">
                                <label htmlFor="performance_security" className="form-labels font-weight500 font-size-subheading">
                                    Performance Security
                                </label>
                                <input
                                    type="text"
                                    id="performance_security"
                                    name="performance_security"
                                    placeholder="Performance Security"
                                    onChange={handleInputChange}
                                    value={formData.performance_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Additional Performance Security */}
                            <div title="Additional Performance Security" className="flex-column">
                                <label htmlFor="additional_performance_security" className="form-labels font-weight500 font-size-subheading">
                                    Additional Performance Security
                                </label>
                                <input
                                    type="text"
                                    id="additional_performance_security"
                                    name="additional_performance_security"
                                    placeholder="Additional Performance Security"
                                    onChange={handleInputChange}
                                    value={formData.additional_performance_security}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Mobilization Advance After AD */}
                            <div title="Mobilization Advance After AD" className="flex-column">
                                <label htmlFor="mobilization_advance_after_AD" className="form-labels font-weight500 font-size-subheading">
                                    Mobilization Advance After AD
                                </label>
                                <input
                                    type="text"
                                    id="mobilization_advance_after_AD"
                                    name="mobilization_advance_after_AD"
                                    placeholder="Mobilization Advance After AD"
                                    onChange={handleInputChange}
                                    value={formData.mobilization_advance_after_AD}
                                    className="form-input-div"
                                />
                            </div>

                            {/* Approval of GAD of ROB */}
                            <div title="Approval of GAD of ROB" className="flex-column">
                                <label htmlFor="approval_of_GAD_of_ROB" className="form-labels font-weight500 font-size-subheading">
                                    Approval of GAD of ROB
                                </label>
                                <input
                                    type="text"
                                    id="approval_of_GAD_of_ROB"
                                    name="approval_of_GAD_of_ROB"
                                    placeholder="Approval of GAD of ROB"
                                    onChange={handleInputChange}
                                    value={formData.approval_of_GAD_of_ROB}
                                    className="form-input-div"
                                />
                            </div>
                        </div>

                        {/* Form Buttons */}
                        <div className="button-models justifycontentimportant" style={{ gap: "24px" }}>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="model-button font-weight500 model-button-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={handleFormSubmit}
                                className="model-button font-weight500 model-button-submit"
                                disabled={loading}
                            >
                                Submit
                            </button>
                        </div>

                        {/* Error Message */}
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </form>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};




const DeleteProject = ({ i, refreshProjects }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(`${BASE_URL}/project_details/project/${i.id}/`);

            if (res.status === 200) {
                await refreshProjects();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully.");

            } else {
                toast.dismiss(loadingToastId);
                toast.error("Failed to delete data!");
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Project" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Project {i.project_short_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Project {i.project_short_name}
                        <div className="button-models">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button font-weight500  model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddContractor = ({
    projectId,
    getProjectContractorDetails,
    getProjects,
    getDetails,
    onAddContractor,
    contractor,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        project: projectId,
        name: "",
        cost: "",
        project_length: "",
        contractor_bid_due_date: null,
        loa_award_date: null,
        agreement_date: null,
        project_duration: "",
        commencement_date: null,
        actual_completion_date: null,
        schedule_completion_date: null,

        actual_construction_completion_date: null,
        schedule_construction_completion_date: null,
        contractor_address: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateEotForm = () => {
        const newErrors = {};
        const requiredFields = [
            "name",
            "cost",
            "project_length",
            "project_duration",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAxiosError = (err) => {
        handleErrorToast(err);
    };

    const handlePost = async (e) => {
        e.preventDefault();
        if (validateEotForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const res = await axios.post(
                    `${BASE_URL}/configuration/contractor/`,
                    formData
                );

                if (res.status === 200) {
                    if (onAddContractor) {
                        onAddContractor(); // Call the callback to notify the parent
                    }
                    await getProjectContractorDetails();
                    await getProjects();
                    getDetails();
                    handleClose();
                } else {
                    toast.error(`Error: ${res.statusText}`);
                }
            } catch (err) {
                handleAxiosError(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Add Contractor"
                className="upload-svg"
                onClick={() => setShow(true)}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <g clip-path="url(#clip0_1415_3177)">
                        <path
                            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_1415_3177">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                    </defs>
                </svg>{" "}
                Consultant
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Contractor Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar
                    />
                    <form onSubmit={handlePost}>
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Contractor Name">
                                    Contractor Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    title="Contractor Name"
                                    placeholder="Name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.name ? "error" : inputState.name ? "success" : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>
                            <div title="Contractor Address" className="flex-column">
                                <label
                                    htmlFor="contractor_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Contractor Address
                                </label>
                                <textarea
                                    type="text"
                                    id="contractor_address"
                                    name="contractor_address"
                                    placeholder="Contractor Address"
                                    onChange={handleInputChange}
                                    rows="50"
                                    cols="100"
                                    value={formData.contractor_address}
                                    className={`form-input width-20vw ${errors.contractor_address
                                        ? "error"
                                        : inputState.contractor_address
                                            ? "success"
                                            : ""
                                        }`}

                                />
                                {errors.contractor_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_address}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="cost">
                                    Cost<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    title="Cost"
                                    name="cost"
                                    placeholder="Cost"
                                    value={formData.cost}
                                    onChange={handleInputChange}
                                    className={`form-input-date width-20vw ${errors.cost ? "error" : inputState.cost ? "success" : ""
                                        }`}
                                />
                                {errors.cost && (
                                    <span className="error-message font-size-text">
                                        {errors.cost}
                                    </span>
                                )}
                            </div>

                            <div title="Project Length" className="flex-column">
                                <label
                                    htmlFor="project_length"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Project Length (in kms)<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="project_length"
                                    name="project_length"
                                    placeholder="10"
                                    onChange={handleInputChange}
                                    value={formData.project_length}
                                    className={`form-input-date width-20vw ${errors.project_length
                                        ? "error"
                                        : inputState.project_length
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.project_length && (
                                    <span className="error-message font-size-text ">
                                        {errors.project_length}
                                    </span>
                                )}
                            </div>


                            <div title="Project Duration" className="flex-column">
                                <label
                                    htmlFor="project_duration"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Project Duration (in months)
                                    <span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="project_duration"
                                    name="project_duration"
                                    placeholder="Project Duration"
                                    onChange={handleInputChange}
                                    value={formData.project_duration}
                                    className={`form-input-date width-20vw ${errors.project_duration
                                        ? "error"
                                        : inputState.project_duration
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.project_duration && (
                                    <span className="error-message font-size-text ">
                                        {errors.project_duration}
                                    </span>
                                )}
                            </div>

                            <div title="Contractor Bid Due Date" className="flex-column">
                                <label
                                    htmlFor="contractor_bid_due_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Contractor Bid Due Date
                                </label>
                                <input
                                    type="date"
                                    id="contractor_bid_due_date"
                                    name="contractor_bid_due_date"
                                    placeholder="Contractor Bid Due Date"
                                    onChange={handleInputChange}
                                    value={formData.contractor_bid_due_date}
                                    className={`form-input-date width-20vw ${errors.contractor_bid_due_date
                                        ? "error"
                                        : inputState.contractor_bid_due_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.contractor_bid_due_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_bid_due_date}
                                    </span>
                                )}
                            </div>

                            <div title="LOA Date" className="flex-column">
                                <label
                                    htmlFor="loa_award_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    LOA Date
                                </label>
                                <input
                                    type="date"
                                    id="loa_award_date"
                                    name="loa_award_date"
                                    min={formData.contractor_bid_due_date}
                                    placeholder="Award Date"
                                    onChange={handleInputChange}
                                    value={formData.loa_award_date}
                                    className={`form-input-date width-20vw ${errors.loa_award_date
                                        ? "error"
                                        : inputState.loa_award_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.loa_award_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.loa_award_date}
                                    </span>
                                )}
                            </div>

                            <div title="Agreement Date" className="flex-column">
                                <label
                                    htmlFor="agreement_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Agreement Date
                                </label>
                                <input
                                    type="date"
                                    id="agreement_date"
                                    name="agreement_date"
                                    min={formData.contractor_bid_due_date}
                                    placeholder="Agreement Date"
                                    onChange={handleInputChange}
                                    value={formData.agreement_date}
                                    className={`form-input-date width-20vw ${errors.agreement_date
                                        ? "error"
                                        : inputState.agreement_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.agreement_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.agreement_date}
                                    </span>
                                )}
                            </div>

                            <div title="Commencement Date" className="flex-column">
                                <label
                                    htmlFor="commencement_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Commencement Date
                                </label>
                                <input
                                    type="date"
                                    id="commencement_date"
                                    name="commencement_date"
                                    min={formData.loa_award_date}
                                    placeholder="Commencement Date"
                                    onChange={handleInputChange}
                                    value={formData.commencement_date}
                                    className={`form-input-date width-20vw ${errors.commencement_date
                                        ? "error"
                                        : inputState.commencement_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.commencement_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.commencement_date}
                                    </span>
                                )}
                            </div>

                            <div
                                title="Schedule Construction Completion Date"
                                className="flex-column"
                            >
                                <label
                                    htmlFor="schedule_construction_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Schedule Const. Completion Date

                                </label>
                                <input
                                    type="date"
                                    id="schedule_construction_completion_date"
                                    name="schedule_construction_completion_date"
                                    min={formData.commencement_date}
                                    placeholder="Schedule Construction Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.schedule_construction_completion_date}
                                    className={`form-input-date width-20vw ${errors.schedule_construction_completion_date
                                        ? "error"
                                        : inputState.schedule_construction_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.schedule_construction_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.schedule_construction_completion_date}
                                    </span>
                                )}
                            </div>

                            <div title="Schedule Completion Date" className="flex-column">
                                <label
                                    htmlFor="schedule_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Schedule Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="schedule_completion_date"
                                    name="schedule_completion_date"
                                    min={formData.schedule_construction_completion_date}
                                    placeholder="Schedule Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.schedule_completion_date}
                                    className={`form-input-date width-20vw ${errors.schedule_completion_date
                                        ? "error"
                                        : inputState.schedule_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.schedule_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.schedule_completion_date}
                                    </span>
                                )}
                            </div>

                            <div title="Actual Completion Date" className="flex-column">
                                <label
                                    htmlFor="actual_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Actual Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="actual_completion_date"
                                    name="actual_completion_date"
                                    placeholder="Actual Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.actual_completion_date}
                                    className={`form-input-date width-20vw ${errors.actual_completion_date
                                        ? "error"
                                        : inputState.actual_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.actual_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.actual_completion_date}
                                    </span>
                                )}
                            </div>

                            <div
                                title="Actual Construction Completion Date"
                                className="flex-column"
                            >
                                <label
                                    htmlFor="actual_construction_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Actual Const. Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="actual_construction_completion_date"
                                    name="actual_construction_completion_date"
                                    placeholder="Actual Construction Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.actual_construction_completion_date}
                                    className={`form-input-date width-20vw ${errors.actual_construction_completion_date
                                        ? "error"
                                        : inputState.actual_construction_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.actual_construction_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.actual_construction_completion_date}
                                    </span>
                                )}
                            </div>


                        </div>
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-leave font-size-heading"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};



const AddConsultant = ({
    projectId,
    getProjectConsultantDetails,
    getProjects,
    getDetails,
    onAddConsultant,
    consultant,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        project: projectId,
        name: "",
        front_name: "",
        business_name: "",
        contractor_address: "",
        work_type: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleClose = () => setShow(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateEotForm = () => {
        const newErrors = {};
        const requiredFields = [
            "front_name",
            "business_name",
            "contractor_address",
            "work_type",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAxiosError = (err) => {
        handleErrorToast(err);
    };

    const handlePost = async (e) => {
        e.preventDefault();
        if (validateEotForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");
            const updatedFormData = {
                ...formData,
                name: `${formData.front_name} - ${formData.work_type}`

            }
            try {
                const res = await axios.post(
                    `${BASE_URL}/project_details/contractor/`,
                    updatedFormData
                );

                if (res.status === 200) {
                    if (onAddConsultant) {
                        onAddConsultant(); // Call the callback to notify the parent
                    }
                    await getProjectConsultantDetails();
                    await getProjects();
                    getDetails();
                    handleClose();
                } else {
                    toast.error(`Error: ${res.statusText}`);
                }
            } catch (err) {
                handleAxiosError(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Party"
                className="upload-svg"
                onClick={() => setShow(true)}
            >
                <AddwithWhiteCircle />{" "}
                Party
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Party</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar
                    />
                    {/* <form onSubmit={handlePost}>
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Contractor Name">
                                    Business  Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="front_name"
                                    title="Business Name"
                                    placeholder="Business Name"
                                    value={formData.front_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.front_name ? "error" : inputState.front_name ? "success" : ""
                                        }`}
                                />
                                {errors.front_name && (
                                    <span className="error-message font-size-text">
                                        {errors.front_name}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Business Name">
                                    Client Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="business_name"
                                    title="Client Name"
                                    placeholder="Client Name"
                                    value={formData.business_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.business_name ? "error" : inputState.business_name ? "success" : ""
                                        }`}
                                />
                                {errors.business_name && (
                                    <span className="error-message font-size-text">
                                        {errors.business_name}
                                    </span>
                                )}
                            </div>

                            <div title="Address" className="flex-column">
                                <label
                                    htmlFor="contractor_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Address
                                </label>
                                <textarea
                                    type="text"
                                    id="contractor_address"
                                    name="contractor_address"
                                    placeholder="Contractor Address"
                                    onChange={handleInputChange}
                                    rows="50"
                                    cols="100"
                                    value={formData.contractor_address}
                                    className={`form-input width-20vw ${errors.contractor_address
                                        ? "error"
                                        : inputState.contractor_address
                                            ? "success"
                                            : ""
                                        }`}

                                />
                                {errors.contractor_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_address}
                                    </span>
                                )}
                            </div>

                            <div title="Type" className="flex-column">
                                <label htmlFor="work_type" className="form-labels font-weight500 font-size-subheading">
                                    Type <span className="required">*</span>
                                </label>
                                <select
                                    id="work_type"
                                    name="work_type"
                                    placeholder="Work Type"
                                    value={formData.work_type}
                                    onChange={handleInputChange}
                                    className={`form-input-div ${errors.work_type ? "error" : inputState.work_type ? "success" : ""}`}
                                >
                                    <option value="">Select Work Type</option>
                                    <option value="Client">Client</option>
                                    <option value="Consultant">Consultant</option>
                                    <option value="Sub-Contractor">Sub-Contractor</option>
                                    <option value="Authority">Authority</option>
                                    <option value="Design Consultant ">Design Consultant</option>
                                    <option value="Others">Others</option>
                                </select>
                                {errors.work_type && <span className="error-message font-size-text">{errors.work_type}</span>}
                            </div>
                            
                            {
                                formData.work_type === "Others" && <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" title="Business Name">
                                        Work Type Other<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="other_work_type"
                                        title="Other work type"
                                        placeholder="Other work type"
                                        value={formData.other_work_type}
                                        onChange={handleInputChange}
                                        className={`form-input width-20vw ${errors.other_work_type ? "error" : inputState.other_work_type ? "success" : ""
                                            }`}
                                    />
                                    {errors.other_work_type && (
                                        <span className="error-message font-size-text">
                                            {errors.other_work_type}
                                        </span>
                                    )}
                                </div>
                            }

                        </div>
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-leave font-size-heading"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </form> */}

                    <form onSubmit={handlePost}>
                        <div className="form-flex-wrap-grid">
                            {/* Business Name */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Contractor Name">
                                    Business Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="front_name"
                                    title="Business Name"
                                    placeholder="Business Name"
                                    value={formData.front_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.front_name ? "error" : inputState.front_name ? "success" : ""}`}
                                />
                                {errors.front_name && <span className="error-message font-size-text">{errors.front_name}</span>}
                            </div>

                            {/* Client Name */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Business Name">
                                    Client Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="business_name"
                                    title="Client Name"
                                    placeholder="Client Name"
                                    value={formData.business_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.business_name ? "error" : inputState.business_name ? "success" : ""}`}
                                />
                                {errors.business_name && <span className="error-message font-size-text">{errors.business_name}</span>}
                            </div>

                            {/* Address */}
                            <div className="flex-column" title="Address">
                                <label htmlFor="contractor_address" className="form-labels font-weight500 font-size-subheading">
                                    Address
                                </label>
                                <textarea
                                    id="contractor_address"
                                    name="contractor_address"
                                    placeholder="Contractor Address"
                                    onChange={handleInputChange}
                                    value={formData.contractor_address}
                                    className={`form-input width-20vw ${errors.contractor_address ? "error" : inputState.contractor_address ? "success" : ""}`}
                                />
                                {errors.contractor_address && <span className="error-message font-size-text">{errors.contractor_address}</span>}
                            </div>

                            {/* Type */}
                            <div className="flex-column" title="Type">
                                <label htmlFor="work_type" className="form-labels font-weight500 font-size-subheading">
                                    Type <span className="required">*</span>
                                </label>
                                <select
                                    id="work_type"
                                    name="work_type"
                                    value={formData.work_type}
                                    onChange={handleInputChange}
                                    className={`form-input-div ${errors.work_type ? "error" : inputState.work_type ? "success" : ""}`}
                                >
                                    <option value="">Select Work Type</option>
                                    <option value="Client">Client</option>
                                    <option value="Consultant">Consultant</option>
                                    <option value="Sub-Contractor">Sub-Contractor</option>
                                    <option value="Authority">Authority</option>
                                    <option value="Design Consultant">Design Consultant</option>
                                    <option value="Others">Others</option>
                                </select>
                                {errors.work_type && <span className="error-message font-size-text">{errors.work_type}</span>}
                            </div>

                            {/* Others Field */}
                            {formData.work_type === "Others" && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" title="Business Name">
                                        Work Type Other<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="other_work_type"
                                        title="Other work type"
                                        placeholder="Other work type"
                                        value={formData.other_work_type}
                                        onChange={handleInputChange}
                                        className={`form-input width-20vw ${errors.other_work_type ? "error" : inputState.other_work_type ? "success" : ""}`}
                                    />
                                    {errors.other_work_type && <span className="error-message font-size-text">{errors.other_work_type}</span>}
                                </div>
                            )}
                        </div>

                        {/* Submit Button */}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-leave font-size-heading"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Add"}
                            </button>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>
        </>
    );
};


const UpdateConsultant = ({
    i,
    projectId,
    contractor,
    getContractorDetails,
    getProjectContractorDetails,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        project: projectId,
        name: "",
        front_name: "",
        business_name: "",
        contractor_address: "",
        work_type: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleClose = () => setShow(false);

    const handleShow = () => {
        setShow(true);
        const fullName = i?.name || "";
        const nameParts = fullName.split(" - ");
        const frontName = nameParts[0] || "";
        const businessName = nameParts[1] || "";

        setFormData({
            ...i,
            front_name: frontName.trim(),
            business_name: businessName.trim(),
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateEotForm = () => {
        const newErrors = {};
        const requiredFields = [
            "front_name",
            "business_name",
            "contractor_address",
            "work_type",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAxiosError = (err) => {
        handleErrorToast(err);
    };

    const handlePost = async (e) => {
        e.preventDefault();
        if (validateEotForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");
            const updatedFormData = {
                ...formData,
                name: `${formData.front_name} - ${formData.work_type}`
            }
            try {
                const res = await axios.put(
                    `${BASE_URL}/project_details/contractor/${contractor}/`,
                    updatedFormData
                );

                if (res.status === 200) {
                    await getContractorDetails();
                    await getProjectContractorDetails();
                    handleClose();
                } else {
                    toast.error(`Error: ${res.statusText}`);
                }
            } catch (err) {
                handleAxiosError(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Update Party"
                className="upload-svg"
                onClick={handleShow}
            >
                <UpdatePencilWhite />{" "}
                Party
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Party</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar
                    />
                    <form onSubmit={handlePost}>
                        <div className="form-flex-wrap-grid">
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Contractor Name">
                                    Business Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="front_name"
                                    title="Business Name"
                                    placeholder="Business Name"
                                    value={formData.front_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.front_name ? "error" : inputState.front_name ? "success" : ""
                                        }`}
                                />
                                {errors.front_name && (
                                    <span className="error-message font-size-text">
                                        {errors.front_name}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Client Name">
                                    Client Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="business_name"
                                    title="Client Name"
                                    placeholder="Client Name"
                                    value={formData.business_name}
                                    onChange={handleInputChange}
                                    className={`form-input width-20vw ${errors.business_name ? "error" : inputState.business_name ? "success" : ""
                                        }`}
                                />
                                {errors.business_name && (
                                    <span className="error-message font-size-text">
                                        {errors.business_name}
                                    </span>
                                )}
                            </div>

                            <div title="Address" className="flex-column">
                                <label
                                    htmlFor="contractor_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Address
                                </label>
                                <textarea
                                    type="text"
                                    id="contractor_address"
                                    name="contractor_address"
                                    placeholder="Contractor Address"
                                    onChange={handleInputChange}
                                    rows="50"
                                    cols="100"
                                    value={formData.contractor_address}
                                    className={`form-input width-20vw ${errors.contractor_address
                                        ? "error"
                                        : inputState.contractor_address
                                            ? "success"
                                            : ""
                                        }`}

                                />
                                {errors.contractor_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_address}
                                    </span>
                                )}
                            </div>

                            {/* Type */}
                            <div title="Type" className="flex-column">
                                <label htmlFor="work_type" className="form-labels font-weight500 font-size-subheading">
                                    Type <span className="required">*</span>
                                </label>
                                <select
                                    id="work_type"
                                    name="work_type"
                                    placeholder="Work Type"
                                    value={formData.work_type}
                                    onChange={handleInputChange}
                                    className={`form-input-div ${errors.work_type ? "error" : inputState.work_type ? "success" : ""}`}
                                >
                                    <option value="">Select Work Type</option>
                                    <option value="Client">Client</option>
                                    <option value="Consultant">Consultant</option>
                                    <option value="Sub-Contractor">Sub-Contractor</option>
                                    <option value="Authority">Authority</option>
                                    <option value="Design Consultant ">Design Consultant</option>
                                    <option value="Others">Others</option>
                                </select>
                                {errors.work_type && <span className="error-message font-size-text">{errors.work_type}</span>}
                            </div>
                            {
                                formData.work_type === "Others" && <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" title="Business Name">
                                        Work Type Other<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="other_work_type"
                                        title="Other work type"
                                        placeholder="Other work type"
                                        value={formData.other_work_type}
                                        onChange={handleInputChange}
                                        className={`form-input width-20vw ${errors.other_work_type ? "error" : inputState.other_work_type ? "success" : ""
                                            }`}
                                    />
                                    {errors.other_work_type && (
                                        <span className="error-message font-size-text">
                                            {errors.other_work_type}
                                        </span>
                                    )}
                                </div>
                            }

                        </div>
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-leave font-size-heading"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "Adding..." : "Update"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};


const ProjectProgressBar = ({ data }) => {
    const renderCustomLabel = ({ x, y, width, height, value, index, dataKey }) => {
        const midX = x + width / 2;
        const midY = y + height / 2;
        const label = dataKey === 'Physical' ? 'Physical' : 'Financial';

        return (
            <text
                x={midX}
                y={midY}
                fill="#fff"
                textAnchor="middle"
                dominantBaseline="middle"
                transform={`rotate(-90, ${midX}, ${midY})`}
                className="font-size-subheading"
            >
                {label}
            </text>
        );
    };


    return (
        <div style={{ padding: 0 }} className="width-5vw">
            <ResponsiveContainer height={200} width="100%">
                <BarChart
                    margin={{
                        top: 15,
                        right: 0,
                        left: 0,
                        bottom: 0,
                    }}
                    barGap={15}
                    barCategoryGap={30}
                    data={data}>
                    <CartesianGrid horizontal="true" vertical="" strokeDasharray="10 6" />
                    <XAxis dataKey="month" />
                    <Tooltip />
                    <Bar label={{ position: 'top' }} legendType="line" dataKey="Physical" fill="#2576BC" barSize={20} radius={7} >
                        <LabelList content={(props) => renderCustomLabel({ ...props, dataKey: 'Physical' })} />
                    </Bar>
                    <Bar label={{ position: 'top' }} legendType="line" dataKey="Financial" fill="#00dec7" barSize={20} radius={7} >
                        <LabelList content={(props) => renderCustomLabel({ ...props, dataKey: 'Financial' })} />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

const UpdateContractor = ({
    projectId,
    i,
    contractor,
    getContractorDetails,
    getProjectContractorDetails,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        project: projectId,
        name: "",
        front_name: "",
        business_name: "",
        contractor_address: "",
        work_type: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleClose = () => setShow(false);

    const handleShow = () => {
        setShow(true);
        setFormData(i);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (e.target.type === "date") {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value || null, // Set to null if cleared
            }));
        } else {

            setFormData({
                ...formData,
                [name]: value,
            });
        }
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
    };

    const validateEotForm = () => {
        const newErrors = {};
        const requiredFields = [
            "front_name",
            "business_name",
            "contractor_address",
            "work_type",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required!`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleAxiosError = (err) => {
        handleErrorToast(err);
    };

    const handlePost = async (e) => {
        e.preventDefault();
        if (validateEotForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");
            const updatedFormData = {
                ...formData,
                name: `${formData.front_name} - ${formData.business_name}`
            }
            try {
                const res = await axios.put(
                    `${BASE_URL}/project_details/contractor/${contractor}/`,
                    updatedFormData
                );

                if (res.status === 200) {
                    await getContractorDetails();
                    await getProjectContractorDetails();
                    handleClose();
                } else {
                    toast.error(`Error: ${res.statusText}`);
                }
            } catch (err) {
                handleAxiosError(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Update Contractor"
                className="upload-svg"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="white"
                    viewBox="0 0 24 24"
                    id="pen-new-square"
                >
                    <path
                        fill=""
                        fill-rule="evenodd"
                        d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
                        clip-rule="evenodd"
                    ></path>
                    <path
                        fill=""
                        fill-rule="evenodd"
                        d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
                        clip-rule="evenodd"
                    ></path>
                </svg>{" "}
                Contractor
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Contractor Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar
                    />
                    <form onSubmit={handlePost}>
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="Name">
                                    Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    title="Contractor Name"
                                    placeholder="Name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>
                            <div title="Contractor Address" className="flex-column">
                                <label
                                    htmlFor="contractor_address"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Contractor Address
                                </label>
                                <textarea
                                    type="text"
                                    id="contractor_address"
                                    name="contractor_address"
                                    placeholder="Contractor Address"
                                    onChange={handleInputChange}
                                    rows="50"
                                    cols="100"
                                    value={formData.contractor_address}
                                    className={`form-input ${errors.contractor_address
                                        ? "error"
                                        : inputState.contractor_address
                                            ? "success"
                                            : ""
                                        }`}

                                />
                                {errors.contractor_address && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_address}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading" title="cost">
                                    Cost<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    title="Cost"
                                    name="cost"
                                    placeholder="Cost"
                                    value={formData.cost}
                                    onChange={handleInputChange}
                                    className={`form-input-date width-17vw ${errors.cost ? "error" : inputState.cost ? "success" : ""
                                        }`}
                                />
                                {errors.cost && (
                                    <span className="error-message font-size-text">
                                        {errors.cost}
                                    </span>
                                )}
                            </div>

                            <div title="Project Length" className="flex-column">
                                <label
                                    htmlFor="project_length"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Project Length (in kms)<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="project_length"
                                    name="project_length"
                                    placeholder="10"
                                    onChange={handleInputChange}
                                    value={formData.project_length}
                                    className={`form-input-date width-17vw ${errors.project_length
                                        ? "error"
                                        : inputState.project_length
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.project_length && (
                                    <span className="error-message font-size-text ">
                                        {errors.project_length}
                                    </span>
                                )}
                            </div>


                            <div title="Project Duration" className="flex-column">
                                <label
                                    htmlFor="project_duration"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Project Duration (in months)
                                    <span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="project_duration"
                                    name="project_duration"
                                    placeholder="Project Duration"
                                    onChange={handleInputChange}
                                    value={formData.project_duration}
                                    className={`form-input-date width-17vw ${errors.project_duration
                                        ? "error"
                                        : inputState.project_duration
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.project_duration && (
                                    <span className="error-message font-size-text ">
                                        {errors.project_duration}
                                    </span>
                                )}
                            </div>

                            <div title="Contractor Bid Due Date" className="flex-column">
                                <label
                                    htmlFor="contractor_bid_due_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Contractor Bid Due Date
                                </label>
                                <input
                                    type="date"
                                    id="contractor_bid_due_date"
                                    name="contractor_bid_due_date"
                                    placeholder="Contractor Bid Due Date"
                                    onChange={handleInputChange}
                                    value={formData.contractor_bid_due_date}
                                    className={`form-input-date width-17vw ${errors.contractor_bid_due_date
                                        ? "error"
                                        : inputState.contractor_bid_due_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.contractor_bid_due_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.contractor_bid_due_date}
                                    </span>
                                )}
                            </div>

                            <div title="LOA Date" className="flex-column">
                                <label
                                    htmlFor="loa_award_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    LOA Date
                                </label>
                                <input
                                    type="date"
                                    id="loa_award_date"
                                    name="loa_award_date"
                                    min={formData.contractor_bid_due_date}
                                    placeholder="Award Date"
                                    onChange={handleInputChange}
                                    value={formData.loa_award_date}
                                    className={`form-input-date width-17vw ${errors.loa_award_date
                                        ? "error"
                                        : inputState.loa_award_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.loa_award_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.loa_award_date}
                                    </span>
                                )}
                            </div>

                            <div title="Agreement Date" className="flex-column">
                                <label
                                    htmlFor="agreement_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Agreement Date
                                </label>
                                <input
                                    type="date"
                                    id="agreement_date"
                                    name="agreement_date"
                                    min={formData.contractor_bid_due_date}
                                    placeholder="Agreement Date"
                                    onChange={handleInputChange}
                                    value={formData.agreement_date}
                                    className={`form-input-date width-17vw ${errors.agreement_date
                                        ? "error"
                                        : inputState.agreement_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.agreement_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.agreement_date}
                                    </span>
                                )}
                            </div>

                            <div title="Commencement Date" className="flex-column">
                                <label
                                    htmlFor="commencement_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Commencement Date
                                </label>
                                <input
                                    type="date"
                                    id="commencement_date"
                                    name="commencement_date"
                                    min={formData.loa_award_date}
                                    placeholder="Commencement Date"
                                    onChange={handleInputChange}
                                    value={formData.commencement_date}
                                    className={`form-input-date width-17vw ${errors.commencement_date
                                        ? "error"
                                        : inputState.commencement_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.commencement_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.commencement_date}
                                    </span>
                                )}
                            </div>

                            <div
                                title="Schedule Construction Completion Date"
                                className="flex-column"
                            >
                                <label
                                    htmlFor="schedule_construction_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Schedule Const. Completion Date

                                </label>
                                <input
                                    type="date"
                                    id="schedule_construction_completion_date"
                                    name="schedule_construction_completion_date"
                                    min={formData.commencement_date}
                                    placeholder="Schedule Construction Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.schedule_construction_completion_date}
                                    className={`form-input-date width-17vw ${errors.schedule_construction_completion_date
                                        ? "error"
                                        : inputState.schedule_construction_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.schedule_construction_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.schedule_construction_completion_date}
                                    </span>
                                )}
                            </div>

                            <div title="Schedule Completion Date" className="flex-column">
                                <label
                                    htmlFor="schedule_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Schedule Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="schedule_completion_date"
                                    name="schedule_completion_date"
                                    min={formData.schedule_construction_completion_date}
                                    placeholder="Schedule Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.schedule_completion_date}
                                    className={`form-input-date width-17vw ${errors.schedule_completion_date
                                        ? "error"
                                        : inputState.schedule_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.schedule_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.schedule_completion_date}
                                    </span>
                                )}
                            </div>

                            <div title="Actual Completion Date" className="flex-column">
                                <label
                                    htmlFor="actual_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Actual Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="actual_completion_date"
                                    name="actual_completion_date"
                                    placeholder="Actual Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.actual_completion_date}
                                    className={`form-input-date width-17vw ${errors.actual_completion_date
                                        ? "error"
                                        : inputState.actual_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.actual_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.actual_completion_date}
                                    </span>
                                )}
                            </div>

                            <div
                                title="Actual Construction Completion Date"
                                className="flex-column"
                            >
                                <label
                                    htmlFor="actual_construction_completion_date"
                                    className="form-labels  font-weight500    font-size-subheading"
                                >
                                    Actual Const. Completion Date
                                </label>
                                <input
                                    type="date"
                                    id="actual_construction_completion_date"
                                    name="actual_construction_completion_date"
                                    placeholder="Actual Construction Completion Date"
                                    onChange={handleInputChange}
                                    value={formData.actual_construction_completion_date}
                                    className={`form-input-date width-17vw ${errors.actual_construction_completion_date
                                        ? "error"
                                        : inputState.actual_construction_completion_date
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.actual_construction_completion_date && (
                                    <span className="error-message font-size-text ">
                                        {errors.actual_construction_completion_date}
                                    </span>
                                )}
                            </div>


                        </div>
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-leave font-size-heading"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? "updating..." : "Update"}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteContractor = ({ consultancyDetailsDetails, contractor, getProjectContractorDetails, getcontractor, getproject }) => {
    const [show, setShow] = useState(false);
    // console.log(contractor, "conractors")
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project_details/contractor/${contractor}/`
            );

            if (res.status === 200) {
                // await getProjectContractorDetails();
                // await getproject();
                setShow(false);
                toast.success("Deleted Successfully");
                toast.dismiss(loadingToastId);
                window.location.reload()

            } else {
                // alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Contractor"
                className="model-delete-button"
                onClick={handleShow}
                style={{ background: "#2576bc" }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z" fill="#FFF"></path></svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Contractor</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Contractor  {consultancyDetailsDetails?.name
                            ? consultancyDetailsDetails.name.split(" - ")[0] || consultancyDetailsDetails.name
                            : "-"}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



export {
    AddProjectDetails,
    UpdateProjectAllDetails,
    DeleteProject,

    AddContractor,
    UpdateContractor,
    DeleteContractor,

    AddConsultant,
    UpdateConsultant,

    ProjectProgressBar,



};
